<template>
    <td-table
        :columns="columns"
        ref="historyTable"
        :hasPage="true"
        :hasMutiSelect="false"
        :dataSource="tableData"
        :pageSize="pageSize"
        :height="400"
        :currentPage="currentPage"
        :total="total"
        :rowKey="rowKey"
        @handleSizeChange="handleSizeChange"
        @currentChange="currentChange"
    ></td-table>
</template>
<script>
import Api from "../assets/api.js";
export default {
  // props: ['title', 'dialogLeaveBillVisible', 'editItem', 'sIdDisabled'],
  props: {
    processId: {
      type: String,
      default: function() {
        return "";
      }
    },
    taskKey: {
      type: Boolean,
      default: function() {
        return true;
      }
    },
    taskName: {
      type: Boolean,
      default: function() {
        return true;
      }
    },
    assigneeName: {
      type: Boolean,
      default: function() {
        return true;
      }
    },
    comment: {
      type: Boolean,
      default: function() {
        return true;
      }
    },
    completeTime: {
      type: Boolean,
      default: function() {
        return true;
      }
    },
    columnsName: {
      type: Array,
      default: function() {
        return [
          this.$t("pgCommon.TASK_KEY"),
          this.$t("pgCommon.TASK_NAME"),
          this.$t("pgCommon.DEAL_PERSON"),
          this.$t("pgCommon.COMMENT"),
          this.$t("pgCommon.COMPLETED_TIME")
        ];
      }
    }
  },
  created() {
    this.btnQuery();
  },
  // 定义变量
  data() {
    return {
      loading: false, // 按钮是否为加载状态
      permissionsView: ["workflow:view"],
      permissionsEdit: ["workflow:edit"],
      permissionsAdd: ["workflow:add"],
      tableData: [],
      rowKey: "taskId",
      pageSize: 10, // 每页条数
      currentPage: 1, // 当前页
      total: 0, // 总条数
      columns: [
        {
          prop: "taskKey",
          align: "left",
          label: this.columnsName[0],
          showColumn: this.taskKey,
          showOverflowTooltip: true
        },
        {
          prop: "taskName",
          align: "left",
          label: this.columnsName[1],
          showColumn: this.taskName,
          showOverflowTooltip: true
        },
        {
          prop: "assigneeName",
          align: "left",
          label: this.columnsName[2],
          showColumn: this.assigneeName,
          showOverflowTooltip: true
        },
        {
          prop: "comment",
          label: this.columnsName[3],
          align: "left",
          showColumn: this.comment,
          showOverflowTooltip: true
        },
        {
          prop: "completeTime",
          label: this.columnsName[4],
          align: "center",
          showColumn: this.completeTime,
          showOverflowTooltip: true
        }
      ]
    };
  },
  // 定义并实现方法体
  methods: {
    btnQuery() {
      let hisTaskParam = {
        isNeedPage: true,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        processId: this.processId,
        isFinished: true,
        systemId: sessionStorage.systemId,
        isDesc: true
      };
      if (hisTaskParam.processId != "" && hisTaskParam.processId != null) {
        Api.findHisTask(JSON.stringify(hisTaskParam), response => {
          if (response.status !== this.$common.login.RESPONSE_STATUS) {
            this.$message({
              type: "error",
              showClose: true,
              message: this.$t("error.ERROR_RESPONSE")
            });
            return;
          }
          if (
            response.data.statusCode !==
            this.$common.requestCode.SUCCESS_INFO_CODE
          ) {
            this.$message({
              type: "error",
              showClose: true,
              message: response.data.statusMessage
            });
            this.$log.error(
              "/activitiDemo/findHisTask",
              response.data.statusMessage
            );
            return;
          }
          let tableRows = response.data.content;
          for (let i = 0; i < tableRows.length; i++) {
            if (tableRows[i].comments.length > 0) {
              tableRows[i].comment = tableRows[i].comments[0].message;
            }
          }
          this.tableData = tableRows;
          this.total = response.data.count;
        });
      }
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.btnQuery();
    },
    // 获取当前页
    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.btnQuery();
    }
  }
};
</script>
